export const hasMap = (reportContent) => reportContent && reportContent.blocks.some(blockIsMap);

const blockIsMap = (b) => b.type === "atomic" && b.data && b.data.type === "map";

export const hasImages = (reportContent) => reportContent && reportContent.blocks.some(isBlockWithImage);

const isBlockWithImage = (block) =>
  block.type === "atomic" &&
  block.data &&
  block.data.type === "gallery" &&
  block.data.imageIds &&
  block.data.imageIds[0];

// TODO: give the user a way to override the default cover image from the report editor
export const coverImage = (reportContent) => {
  const firstBlockWithImage = reportContent.blocks.find(isBlockWithImage);
  if (!firstBlockWithImage) {
    return null;
  }
  return firstBlockWithImage.data.imageIds[0];
};

export const mapPhoto = (reportContent) => {
  const firstMapBlock = reportContent.blocks.find(blockIsMap);
  if (!firstMapBlock) {
    return null;
  }
  return mapPhotoUrl(firstMapBlock.data.rideId);
};

const mapPhotoUrl = (rideId) => `/trips/full/${rideId}.png`;

const mediumPhoto = (id) => `/photos/medium/${id}.jpg`;

export const getReportCover = (report) => {
  if (report.featuredImage) {
    return mediumPhoto(report.featuredImage);
  }
  return (
    (hasImages(report.reportContent) && mediumPhoto(coverImage(report.reportContent))) ||
    (hasMap(report.reportContent) && mapPhoto(report.reportContent)) ||
    mapPhotoUrl(report.rides[0])
  );
};
